
export const classic = {
  
  klass: {

    // The element states
    input: 'picker-classic__input',
    active: 'picker-classic__input--active',

    // The root picker and states *
    picker: 'picker-classic',
    opened: 'picker-classic--opened',
    focused: 'picker-classic--focused',

    // The picker holder
    holder: 'picker-classic__holder',

    // The picker frame, wrapper, and box
    frame: 'picker-classic__frame',
    wrap: 'picker-classic__wrap',
    box: 'picker-classic__box',

    // The picker header
    header: 'picker-classic__header',

    // Month navigation
    navPrev: 'picker-classic__nav--prev',
    navNext: 'picker-classic__nav--next',
    navDisabled: 'picker-classic__nav--disabled',

    // Month & year labels
    month: 'picker-classic__month',
    year: 'picker-classic__year',

    // Month & year dropdowns
    selectMonth: 'picker-classic__select--month',
    selectYear: 'picker-classic__select--year',

    // Table of dates
    table: 'picker-classic__table',

    // Weekday labels
    weekdays: 'picker-classic__weekday',

    // Day states
    day: 'picker-classic__day',
    disabled: 'picker-classic__day--disabled',
    selected: 'picker-classic__day--selected',
    highlighted: 'picker-classic__day--highlighted',
    now: 'picker-classic__day--today',
    infocus: 'picker-classic__day--infocus',
    outfocus: 'picker-classic__day--outfocus',

    // The picker footer
    footer: 'picker-classic__footer',

    // Today, clear, & close buttons
    buttonClear: 'picker-classic__button--clear',
    buttonClose: 'picker-classic__button--close',
    buttonToday: 'picker-classic__button--today'
  }
};


export const modal = {

  klass: {
    // The element states
    input: 'picker-modal__input',
    active: 'picker-modal__input--active',

    // The root picker and states *
    picker: 'picker-modal',
    opened: 'picker-modal--opened',
    focused: 'picker-modal--focused',

    // The picker holder
    holder: 'picker-modal__holder',

    // The picker frame, wrapper, and box
    frame: 'picker-modal__frame',
    wrap: 'picker-modal__wrap',
    box: 'picker-modal__box',

    // The picker header
    header: 'picker-modal__header',

    // Month navigation
    navPrev: 'picker-modal__nav--prev',
    navNext: 'picker-modal__nav--next',
    navDisabled: 'picker-modal__nav--disabled',

    // Month & year labels
    month: 'picker-modal__month',
    year: 'picker-modal__year',

    // Month & year dropdowns
    selectMonth: 'picker-modal__select--month',
    selectYear: 'picker-modal__select--year',

    // Table of dates
    table: 'picker-modal__table',

    // Weekday labels
    weekdays: 'picker-modal__weekday',

    // Day states
    day: 'picker-modal__day',
    disabled: 'picker-modal__day--disabled',
    selected: 'picker-modal__day--selected',
    highlighted: 'picker-modal__day--highlighted',
    now: 'picker-modal__day--today',
    infocus: 'picker-modal__day--infocus',
    outfocus: 'picker-modal__day--outfocus',

    // The picker footer
    footer: 'picker-modal__footer',

    // Today, clear, & close buttons
    buttonClear: 'picker-modal__button--clear',
    buttonClose: 'picker-modal__button--close',
    buttonToday: 'picker-modal__button--today'
  }
};
